import { useSyncExternalStore } from "react";
import { readSetupTrace, setupTraceEnabled, subscribeSetupTrace } from "../rtc/setupTrace";

/** Explicit developer opt-in only. Normal call pages do not show implementation details. */
export function SetupDiagnostics() {
  const marks = useSyncExternalStore(subscribeSetupTrace, readSetupTrace);
  if (!setupTraceEnabled()) return null;
  return <details open dir="ltr" aria-label="Call setup diagnostics" style={{ background: "white", color: "black", padding: 16, maxWidth: "100%", overflow: "auto" }}>
    <summary>Call setup diagnostics</summary>
    <pre>{marks.map(mark => `${mark.at} +${mark.elapsedMs}ms ${mark.phase}${mark.detail ? ` ${mark.detail}` : ""}`).join("\n")}</pre>
  </details>;
}
